<template>
    <div>
      <ListKasbonKaryawan v-if="islistkasbonKaryawan"
                          @detailListKasbon="showlistkasbon"
                          @backtolistpenggajian="backtopenggajian"
                          @createkasbon="showaddkasbon"
      />
      <ListKasbon v-if="islistkasbon" v-on:backtolistkasbon="showlistkasbonKaryawan" v-on:tambahkasbon="showaddkasbon"
                  v-on:showbayarkasbon="showbayarkasbon" v-on:showdetailkasbon="showdetailkasbon" ref="listkasbon"/>
      <TambahKasbon v-if="istambahkasbon" v-on:backtolistkasbon="showlistkasbonKaryawan"
                    @detailListKasbon="showlistkasbon"
      />
      <BayarKasbon v-if="isbayarkasbon" v-on:backtolistkasbon="showlistkasbons" v-bind:dataidkasbon="datakasbon"
                   v-on:gotoriwayatcicilan="showriwayatkasbon" :idkaryawan="idkaryawan"/>
      <RiwayatCicilKasbon v-if="isriwayatkasbon" v-bind:dataidkasbon="datakasbon"
                          v-on:backtodetailkasbon="showdetailkasbonfromriwayatx" v-on:showbayarkasbon="showbayarkasbonfromriwayat"
      />
      <DetailKasbon v-if="isDetailkasbon" v-bind:dataidkasbon="datakasbon" v-on:backtolistkasbon="showlistkasbons"
                    v-on:gotoriwayatcicilan="showriwayatkasbon"/>
    </div>
</template>

<script>
    import ListKasbon from "./ListKasbon";
    import BayarKasbon from "./BayarKasbon";
    import TambahKasbon from "./TambahKasbon";
    import RiwayatCicilKasbon from "./RiwayatCicilKasbon";
    import DetailKasbon from "./DetailKasbon";
    import ListKasbonKaryawan from "@/components/penggajian/Kasbon/ListKasbonKaryawan";
    export default {
        name: "AddKasbon",
        components:{
            DetailKasbon,
            ListKasbon,BayarKasbon,TambahKasbon,RiwayatCicilKasbon,ListKasbonKaryawan
        },

        data(){
            return{
                islistkasbonKaryawan: false,
                islistkasbon:false,
                istambahkasbon:false,
                isbayarkasbon:false,
                isriwayatkasbon:false,
                isDetailkasbon:false,

                idkaryawan: "",

                datakasbon:{
                    idkasbon:'',
                    idkaryawankasbon:'',
                    islunas:'0',
                }
            }
        },
        mounted() {
            this.showlistkasbonKaryawan()
        },
        methods:{
            showlistkasbonKaryawan(){
                this.islistkasbonKaryawan = true;
                this.islistkasbon = false;
                this.istambahkasbon = false;
                this.isbayarkasbon = false;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = false;
            },

            showlistkasbon(idkaryawan){
            	this.idkaryawan = idkaryawan

            	this.islistkasbonKaryawan = false
            	this.islistkasbon = true;
            	this.istambahkasbon = false;
            	this.isbayarkasbon = false;
            	this.isriwayatkasbon = false;
            	this.isDetailkasbon = false;
            	setTimeout(() => {
            	    this.$refs.listkasbon.listkasbonx(true, idkaryawan);
            	}, 200)
				window.scrollTo(0,0)
            },

            showlistkasbons(){
                this.islistkasbonKaryawan = false
                this.islistkasbon = true;
                this.istambahkasbon = false;
                this.isbayarkasbon = false;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = false;
                $('#list_kasbon').show();
                setTimeout(() => {
                    this.$refs.listkasbon.listkasbonx(true, this.idkaryawan);
                    this.backButtonPressed(this.$refs.listkasbon.backtolistkasbon)
                }, 200)
            },

            showaddkasbon(){
                this.islistkasbonKaryawan = false
                this.islistkasbon = false;
                this.istambahkasbon = true;
                this.isbayarkasbon = false;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = false;
            },

            showbayarkasbon(val){
                this.islistkasbonKaryawan = false
                this.islistkasbon = true;
                this.istambahkasbon = false;
                this.isbayarkasbon = true;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = false;
                this.datakasbon.idkasbon=val.idkasbon;
                this.datakasbon.idkaryawankasbon=val.idkaryawan;
                $('#list_kasbon').hide();
            },

            showbayarkasbonfromriwayat(val){
                this.islistkasbonKaryawan = false
                this.islistkasbon = true;
                this.istambahkasbon = false;
                this.isbayarkasbon = true;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = false;
                this.datakasbon.idkasbon=val.idkasbon;
                this.datakasbon.idkaryawankasbon=val.idkaryawan;
                this.datakasbon.islunas=val.islunas
                $('#list_kasbon').hide();
            },

            showdetailkasbon(val){
                this.islistkasbonKaryawan = false
                this.islistkasbon = true;
                this.istambahkasbon = false;
                this.isbayarkasbon = false;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = true;
                this.datakasbon.idkasbon=val.idkasbon;
                this.datakasbon.idkaryawankasbon=val.idkaryawan;
                $('#list_kasbon').hide();
                window.scrollTo(0,0)
            },

            showdetailkasbonfromriwayatx(val){
                this.islistkasbonKaryawan = false
                this.islistkasbon = true;
                this.istambahkasbon = false;
                this.isbayarkasbon = false;
                this.isriwayatkasbon = false;
                this.isDetailkasbon = true;
                $('#listpotonganx').hide();
                this.datakasbon.idkasbon=val.idkasbon;
                this.datakasbon.idkaryawankasbon=val.idkaryawan;
                this.datakasbon.islunas=val.islunas
            },

            showriwayatkasbon(val){
                this.islistkasbonKaryawan = false
                this.islistkasbon = true;
                this.istambahkasbon = false;
                this.isbayarkasbon = false;
                this.isriwayatkasbon = true;
                this.isDetailkasbon = false;
                this.datakasbon.idkasbon=val.idkasbon;
                this.datakasbon.idkaryawankasbon=val.idkaryawan;
                this.datakasbon.islunas=val.islunas
                $('#list_kasbon').hide();
                window.scrollTo(0,0)
            },

            backtopenggajian(){
                this.$emit('backtolistpenggajian')
            }
        }
    }
</script>

<style scoped>

</style>